module.exports = __webpack_public_path__ + "static/media/blogPost-circle.f8805bfc.svg";